export default {
  // 实时变化Signature
  makeSignature(params, reqTime) {
    let paramsKeys = Object.keys(params).sort();
    let paramsStr = '';
    for (let paramsKey of paramsKeys) {
      paramsStr += `${paramsKey}=${params[paramsKey]}&`;
    }
    return $.md5(paramsStr + reqTime);
  },

  // 获取网站来源
  //   getUrlParam(name) {
  //       let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  //       let r = window.location.search.substr(1).match(reg);
  //       if (r != null) return unescape(r[2]);
  //       return null;
  //   },

  //   getUrlParam(name) {
  //     return decodeURIComponent((new RegExp('[&#63;|&]' + name + '=' + '([^&;]+&#63;)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  //   },

  //获取地址栏url后的参数值
  //  getUrlParam(key) {
  //     var href = window.location.href;
  //     var url = href.split("?");
  //     if(url.length <= 1){
  //        return "";
  //     }
  //     var params = url[1].split("&");

  //     for(var i=0; i<params.length; i++){
  //        var param = params[i].split("=");
  //        if(key == param[0]){
  //           return param[1];
  //        }
  //     }
  //  },
  getUrlParam(name) {
    let reg = new RegExp('(^|/?|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.href.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  // gTag
  gtag() {
    dataLayer.push(arguments);
  },

  // style函数
  handleScale() {
    let winWidth = $(window).width();
    let winHeight = $(window).height();
    const contScale = Math.min(((winWidth / winHeight) / (1920 / 1080)), ((winHeight / winWidth) / (1080 / 1920)));
    return {
      transform: "matrix(" + contScale + ", 0, 0, " + contScale + ", 0, 0)",
    };
  },
  // 宽高比
  handleVideoSize() {
    const scalex = $(window).width() / 1920;
    const scaley = $(window).height() / 1080;
    const vscale = Math.max(scalex, scaley);
    const vwidth = 1920 * vscale;
    const vheight = 1080 * vscale;

    // $set('width', vwidth + 'px', 'height', vheight + 'px', marginLeft + (-vwidth / 2) + 'px')
    return {
      width: vwidth + 'px',
      height: vheight + 'px',
      marginLeft: (-vwidth / 2) + 'px',
    };
  },
  // 统一链接
  goStore(code) {
    switch (code) {
      case 'os':
        // gtag('event', 'OS_reg');
        window.open(`https://onesto.re/0000766395`, '_blank');
        break;
      case 'gp':
        // gtag('event', 'GP_reg');
        window.open(`https://play.google.com/store/apps/details?id=com.ujoygp.zero9`, '_blank');
        break;
      case 'as':
        // gtag('event', 'AS_reg');
        window.open(`https://apps.apple.com/app/id6444855865`, '_blank');
        break;
        case 'naver':
          // gtag('event', 'AS_reg');
          window.open(`https://game.naver.com/lounge/zero9`, '_blank');
          break;

    }
  },


  goShare(code) {
    switch (code) {
      case 'fb':
        gtag('event', 'FB_page');
        window.open(`https://www.facebook.com/ZeroNineKR/`, '_blank');
        break;
      case 'yt':
        gtag('event', 'YT_page');
        window.open(`https://www.youtube.com/@Zero.9kr`, '_blank');
        break;
      case 'cafe':
        gtag('event', 'CAFE_page');
        window.open(`https://game.naver.com/lounge/zero9`, '_blank');
        break;
      case 'naver':
        gtag('event', 'NAVER_page');
        window.open(`https://game.naver.com/lounge/zero9`, '_blank');
        break;
      case 'os':
        gtag('event', 'OS_reg');
        window.open(`https://zero9onestore.onelink.me/LqL2/959aovbo`, '_blank');
        break;
      case 'gp':
        gtag('event', 'GP_reg');
        window.open(`https://zero9.onelink.me/l1q1/ivp7oc3l`, '_blank');
        break;
      case 'as':
        gtag('event', 'AS_reg');
        window.open(`https://zero9.onelink.me/l1q1/ns77qftm`, '_blank');
        break;
    }
  },
  // 错误码提示
  getErrCode(code) {
    switch (code) {
      case 20001:
        // alert('전화번호 형식 오류')
        ERR_TEXT = "전화번호 형식 오류"
        break;
      case 20002:
        // alert('이메일 형식 오류')
        ERR_TEXT = "이메일 형식 오류"

        break;
      case 20010:
        // alert('이미 예약한 번호입니다')
        ERR_TEXT = "이미 예약한 번호입니다."

        break;
      case 20011:
        // alert( '문자 발송 간격이 너무 짧습니다, %s')
        ERR_TEXT = "문자 발송 간격이 너무 짧습니다."

        break;
      case 20012:
        // alert('문자 발송 횟수 초과, %s')
        ERR_TEXT = "문자 발송 횟수 초과"

        break;
      case 20013:
        // alert( '문자 발송 실패')
        ERR_TEXT = "문자 발송 실패"

        break;
      case 20014:
        // alert( '인증실패')
        ERR_TEXT = "인증실패"

        break;
      case 20015:
        // alert(  '미션이 없습니다')
        ERR_TEXT = "미션이 없습니다."

        break;
      case 20016:
        // alert(  '미션을 완수하셨습니다')
        ERR_TEXT = "미션을 완수하셨습니다"

        break;
      case 20017:
        // alert( '아직 예약 전 입니다')
        ERR_TEXT = "아직 예약 전 입니다."

        break;
      case 20018:
        // alert( '아직 예약 전 입니다')
        ERR_TEXT = "추첨권 수량이 부족합니다."

        break;
    }
  },

  doShare(code) {
    switch (code) {
      case 'fb':
        window.open('https://www.facebook.com/share.php?display=popup&u=' + CDN_URL + '/share_0314/index.html', 'sharer', 'toolbar=0,status=0,resizable=1,width=626,height=436');
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/commonFunction/common.js